import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const About = () => {
  const { dict } = useLanguage();
  const about = dict.about;

  return (
    <section id="about" className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8">
            <img
              src="/img/techrabbits.png"
              alt={about.imageAlt}
              className="rounded-lg shadow-lg"
            />
          </div>
          <div className="md:w-1/2">
            <h2 className="text-3xl font-bold mb-4 text-purple-800">{about.title}</h2>
            <p className="text-gray-700 mb-4">{about.p1}</p>
            <p className="text-gray-700 mb-6">{about.p2}</p>

            <div className="grid grid-cols-2 gap-4 mb-6">
              {about.features.map((feature, index) => (
                <div key={index} className="flex items-center">
                  <div className="text-purple-600 mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                  <span className="text-gray-800">{feature}</span>
                </div>
              ))}
            </div>

            <a
              href="#contact"
              className="inline-block bg-purple-600 text-white font-bold py-3 px-6 rounded-lg shadow hover:bg-purple-700 transition duration-300"
            >
              {about.cta}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
